import { html } from '../application_element/element.js';
import CardOption from '../card_option/element.js';
import translations from './translations.js';
import style from './style.lit.css';
import '../progress_bar/element.js';

/**
 * Represents one option in a poll card
 *
 * @prop percent - Percent of votes for this option
 *
 * @cssprop [--progress-bar-margin: 8px 0 8px 0] Margin of progress bar
 * @cssprop [--progress-bar-color: var(--primary)] Color of progress bar
 * @cssprop [--progress-bar-color-disabled: var(--gray-300)] Color of progress bar when option is disabled
 */

export default class PollOption extends CardOption {
  static styles = [CardOption.styles, style];

  static properties = {
    percent: { type: Number },
  };

  /** @internal */
  static translations = translations;

  static config = {
    icons: {
      plus: '',
      minus: 'check',
      check: 'check',
    },
  };

  constructor() {
    super();
    this.percent = 0;
  }

  // TODO: Get real URLS
  /** @internal */
  get checkUrl() {
    return `/cards/${this.cardId}/items/${this.itemId}/assigns`;
  }

  /** @internal */
  get uncheckUrl() {
    return `${this.checkUrl}/${this.cardId}`;
  }

  /** @internal */
  get detailsUrl() {
    return `/organize_cards/${this.cardId}/assigns?item=${this.itemId}`;
  }

  renderLabel() {
    return html`<ef-label>${Math.round(this.percent)}%</ef-label>`;
  }

  renderColumnLayout() {
    return html`
      <div class="top">
        <div class="left">
          <slot></slot>
          ${this.renderLabel()}
        </div>
        <div class="right">
          ${this.renderAvatars()} ${this.renderActionWrapper()}
        </div>
      </div>
      <div class="bottom">
        <ef-progress-bar .percent=${this.percent}></ef-progress-bar>
      </div>
    `;
  }

  renderRowLayout() {
    return html`
      <div class="top">
        <slot></slot>
        <div class="percent">
          ${this.renderLabel()}
          <ef-progress-bar .percent=${this.percent}></ef-progress-bar>
        </div>
      </div>
      <div class="bottom">
        ${this.renderAvatars()} ${this.renderActionWrapper()}
      </div>
    `;
  }
}

PollOption.registerTagName('ef-poll-option');

customElements.get('ef-poll-option') ||
  customElements.define('ef-poll-option', PollOption);
